export const senso = {
    product_id: "13",
    grid_type: "2",
    cover_image: "/3.webp",
    product_name: "Senso",
    media: ["1.webp", "2.webp", "3.webp", "4.webp", "5.webp", "6.webp"],
    product_price: 267.0,
    product_slug: "senso",
    short_description: "Das SENSO-Regal kombiniert modernes Design mit funktionaler Eleganz. Die Feelwood Pinegrain-Oberfläche verleiht ihm eine weiche, helle Optik, während die schwarze Struktur mit 3D-Textur Tiefe und Ausdruck schafft. Perfekt zum stilvollen Präsentieren oder praktischen Verstauen von Alltagsgegenständen.",
    description: `
    Bringen Sie Stil & Funktionalität in Ihr Zuhause!
    <br><br>
    Das SENSO-Regal verleiht jedem Raum eine stilvolle Note. Die Feelwood Pinegrain
    <br>
    Oberfläche sorgt für eine weiche, helle Optik, während die schwarze Struktur mit ihrer
    <br>
    Textur Tiefe und Ausdruck verleiht. Perfekt zum stilvollen Präsentieren von
    <br>
    Lieblingsstücken oder zum Aufbewahren alltäglicher Essentials.
    <br><br>
    <h6> PRODUCTBESCHREIBUNG </h6>
    <li>Produktname: SENSO</li>
    <li>Typ: Dekoratives und funktionales Regal</li>
    <li>Verwendung: Ideal zur Organisation und Dekoration, perfekt für Bücher, Deko-Elemente und persönliche Gegenstände.</li>
    <br><br>
    <h6> MATERIALIEN & KOMPONENTEN </h6>
    <li>Particleboard: Spanplatte: Schwarzes Design mit 3D-Textur und matter Oberfläche.</li>
    <li>Aluminiumprofil: Silberfarben mit glatter Oberfläche und verschlossenen Endkappen für zusätzliche Stabilität.</li>
    <br><br>
    <h6> MERKMALE & EIGENSCHAFTEN </h6>
    <li>Tragfähigkeit: Das SENSO-Regal kann pro Platte ein Gewicht bis zu 25 kg tragen.</li>
    <li>Langlebig & robust: Widerstandsfähig gegen alltägliche Abnutzung und leichte Stöße.</li>
    <li>Kratzerresistente Oberfläche: Die matte Spanplatte bietet Schutz vor Kratzern und kleinen Gebrauchsspuren.</li>
    <br><br>
    <h6> MONTAGEHINWEISE </h6>
    <li>Lieferung inklusive Schrauben und Befestigungsmaterial für eine einfache und sichere Montage.</h1>
    <li>Eine detaillierte Anleitung liegt bei, um den Aufbau zu erleichtern.</li>
    <br><br>
    <h6> ZUSÄTZLICHE INFORMATIONEN </h6>
    <li>Garantie: 2 Jahre Herstellergarantie auf Material- und Verarbeitungsfehler.</li>
    <li>Pflegehinweise: Mit einem trockenen oder leicht feuchten Tuch abwischen, um Staub zu entfernen. Keine aggressiven Reinigungsmittel verwenden, um die 3D-Textur und die matte Oberfläche zu erhalten. Das Aluminiumprofil mit einem weichen, nicht scheuernden Tuch reinigen. </li>
    `,
    specifications: {
      rows: [
        { name: "Material", value: "Particleboard, Aluminiumprofil" },
        { name: "Abmessungen", value: "78,4cm x 133,5cm x 35cm" },
        { name: "Gewicht", value: "17,5 kg" },
        { name: "Farbe", value: "Schwarze" }
      ],
      description: `Ideal zur Organisation und Dekoration, perfekt für Bücher, Deko-Elemente und persönliche Gegenstände.`,
    },
    category: "Table",
    title_color: "#000000",
    subtitle_color: "#999999",
    price_color: "#000000"
  };
    